import React, { useState, useEffect, useRef } from 'react'
import { LANGS, getLoginLang, setLoginLang } from '../i18n/loginI18n'

// Language picker for the public auth views. Translations are local (see
// src/i18n/loginI18n.js) — the Google Translate widget must NOT be loaded on
// these pages because it breaks the Google Sign-In button overlay. The choice
// is still written to the googtrans cookie so the in-app translator picks it
// up after login.
export default function LoginLangSelector({ onChange }) {
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState(getLoginLang())
  const ref = useRef(null)

  useEffect(() => {
    const handleOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handleOutside)
    return () => document.removeEventListener('mousedown', handleOutside)
  }, [])

  const handleSelect = (code) => {
    setLoginLang(code)
    setSelected(code)
    setOpen(false)
    if (onChange) onChange(code)
  }

  const current = LANGS.find(l => l.code === selected) || LANGS[0]

  return (
    <div ref={ref} translate="no" className="notranslate" style={{ position: 'absolute', top: 14, right: 16, zIndex: 20 }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 7,
          background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.18)',
          borderRadius: 8, padding: '5px 10px 5px 7px', cursor: 'pointer',
          color: 'rgba(255,255,255,.85)', fontSize: 13, lineHeight: 1,
        }}
      >
        <img src={`/languages/${current.flag}.png`} alt={current.label} style={{ width: 20, height: 20, borderRadius: 2 }} />
        <span>{current.label}</span>
        <span style={{ fontSize: 9, opacity: 0.55, marginLeft: 1 }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', right: 0,
          background: 'rgba(0,14,32,.96)', border: '1px solid rgba(255,255,255,.14)',
          borderRadius: 10, padding: '4px 0', minWidth: 156,
          boxShadow: '0 8px 28px rgba(0,0,0,.5)', maxHeight: 300, overflowY: 'auto',
        }}>
          {LANGS.map(lang => (
            <button
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              translate="no"
              style={{
                display: 'flex', alignItems: 'center', gap: 9,
                width: '100%', padding: '8px 14px', background: 'none', border: 'none',
                color: selected === lang.code ? '#fff' : 'rgba(255,255,255,.55)',
                fontWeight: selected === lang.code ? 700 : 400,
                fontSize: 13, cursor: 'pointer', textAlign: 'left',
                borderLeft: selected === lang.code ? '2px solid rgba(255,255,255,.4)' : '2px solid transparent',
              }}
            >
              <img src={`/languages/${lang.flag}.png`} alt={lang.label} style={{ width: 20, height: 20, borderRadius: 2 }} />
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
